import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';
import { MentionCustomizationModel } from '../../Shared/models/mention-customization.model';
import { MonitoringSeriesTypeEnum } from '../../Shared/enums/monitoring-series-type.enum';
import { MentionSearchModel } from '../../Shared/models/mention-search.model';
import { MonitoringBackEndDataSourceModel } from '../../Shared/models/monitoring-back-end-data-source.model';
import { MentionModel } from '../../../api/mentions/model/mention.model';

export class AlertMentionListDisplayElementModel extends DisplayElementModel {
    declare styles: MentionCustomizationModel;
    declare isBoundToGlobalStyles: boolean;
    title: string;

    topicId: number;
    mediaSubscriptionId: number;
    agentId: number;
    themeId: number;

    pageSize: number;
    filterMentionSearchModel: MentionSearchModel;
    // Filter search criteriaId
    searchCriteriaId: number;
    backendDataSource: MonitoringBackEndDataSourceModel;
    readonly dateRangeAllowed: boolean = true;

    isSubscriptionSearch: boolean;
    isThemeSearch: boolean;
    isAgentSearch: boolean;

    mentions: MentionModel[];

    constructor(
        title?: string,
        backendDataSourceType?: MonitoringSeriesTypeEnum,
        backEndDataSourceId?: number,
        pageSize?: number,
        searchCriteriaId?: number,
        searchCriteria?: MentionSearchModel,
        styles?: any
    ) {
        super();

        this.title = title;

        this.isSubscriptionSearch = false;
        this.isThemeSearch = false;
        this.isAgentSearch = false;
        if (backendDataSourceType === MonitoringSeriesTypeEnum.topic) {
            this.topicId = backEndDataSourceId;
        } else if (backendDataSourceType === MonitoringSeriesTypeEnum.subscription) {
            this.mediaSubscriptionId = backEndDataSourceId;
            this.isSubscriptionSearch = true;
        } else if (backendDataSourceType === MonitoringSeriesTypeEnum.socialTopic) {
            this.agentId = backEndDataSourceId;
            this.isAgentSearch = true;
        } else if (backendDataSourceType === MonitoringSeriesTypeEnum.theme) {
            this.themeId = backEndDataSourceId;
            this.isThemeSearch = true;
        }

        if (pageSize === null || pageSize === undefined ) {
            this.pageSize = pageSize;
        } else {
            this.pageSize = pageSize || 10;
        }

        this.searchCriteriaId = searchCriteriaId;

        this.filterMentionSearchModel = searchCriteria;

        this.styles = styles && styles.clone ? styles.clone() : new MentionCustomizationModel(styles);

        // for now we don't populate mentions
        this.mentions = [];
        this.isBoundToGlobalStyles = true;

        this.backendDataSource = new MonitoringBackEndDataSourceModel(
            backendDataSourceType,
            backEndDataSourceId
        );
    }

    canRender(): boolean {
        return true;
    }

    clone(): AlertMentionListDisplayElementModel {
        return new AlertMentionListDisplayElementModel(
            this.title,
            JSON.parse(JSON.stringify(this.styles))
        );
    }

    onUpdate(): boolean {
        return true;
    }

    isEqual(other: AlertMentionListDisplayElementModel): boolean {
        if (!other) {
            return false;
        }

        if (!this.styles.equals(other.styles, true)) {
            return false;
        }
        if (this.title !== other.title) {
            return false;
        }
        return true;
    }
}
